/**
 * Module dependencies.
 */

import { NewsExhibitionsProps } from 'src/types/news-exhibitions';
import {
  QueryObserverBaseResult,
  QueryObserverOptions,
  useQuery
} from 'react-query';
import { fetchNewsDetail } from './fetch-news-exhibitions-detail';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Result` type.
 */

type Result = QueryObserverBaseResult<NewsExhibitionsProps, unknown>;

/**
 * `Options` type.
 */

type Options = QueryObserverOptions<NewsExhibitionsProps> & {
  slug: string;
};

/**
 * Action type.
 */

const actionType = ({ locale, slug }): string => {
  return `${locale}-news-${slug}`;
};

/**
 * `useNewsDetail` hook.
 */

function useNewsDetail(options?: Options): Result {
  const { locale } = useRouter();
  const { slug, ...rest } = options ?? {};
  const variables = useMemo(
    () => ({
      locale,
      slug
    }),
    [locale, slug]
  );

  const result = useQuery(
    [actionType(variables), variables],
    () => {
      return fetchNewsDetail(variables);
    },
    rest
  );

  return result;
}

/**
 * Export `useNewsDetail` hook.
 */

export default useNewsDetail;
